import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';

const EquityMarketTermsByDefault: FC = () => {
  const { t } = useTranslate();

  return (
    <>
      <div className="nav-secciones mb-4">
        <p className="mb-1 fs-13px text-soft">
          <strong>{t('InThisPage')}</strong>
        </p>
        <ul className="list-unstyled mb-0 fs-13px">
          <li>
            <button
              type="button"
              className="btn btn-link p-0 text-left"
              onClick={() =>
                document
                  .getElementById('oferta-venta')
                  ?.scrollIntoView({ behavior: 'smooth' })
              }
            >
              {t('SellOfferConditionsTitle')}
            </button>
          </li>
          <li>
            <button
              type="button"
              className="btn btn-link p-0 text-left"
              onClick={() =>
                document
                  .getElementById('oferta-compra')
                  ?.scrollIntoView({ behavior: 'smooth' })
              }
            >
              {t('BuyOfferConditionsTitle')}
            </button>
          </li>
          <li>
            <button
              type="button"
              className="btn btn-link p-0 text-left"
              onClick={() =>
                document
                  .getElementById('aceptacion')
                  ?.scrollIntoView({ behavior: 'smooth' })
              }
            >
              {t('AcceptanceConditionsTitle')}
            </button>
          </li>
        </ul>
      </div>

      <div className="card card-bordered">
        <div className="card-inner p-4 p-md-5">
          <section id="oferta-venta" className="anchor-block">
            <h5>{t('SellOfferConditionsTitle')}</h5>
            <p
              dangerouslySetInnerHTML={{
                __html: t('SellOfferConditionsIntro'),
              }}
            />

            <h6>{t('OffererRequirements')}</h6>
            <ul className="list mb-4">
              <li>{t('SellOfferReq1')}</li>
              <li>{t('SellOfferReq2')}</li>
              <li>{t('SellOfferReq3')}</li>
            </ul>

            <h6>{t('PublicationEffects')}</h6>
            <ul className="list mb-4">
              <li>{t('SellOfferEffect1')}</li>
              <li>{t('SellOfferEffect2')}</li>
              <li>{t('SellOfferEffect3')}</li>
            </ul>

            <h6>{t('PriceAndPayment')}</h6>
            <p>{t('SellOfferPriceText')}</p>
          </section>

          <hr className="my-4" />

          <section id="oferta-compra" className="anchor-block">
            <h5>{t('BuyOfferConditionsTitle')}</h5>
            <p
              dangerouslySetInnerHTML={{
                __html: t('BuyOfferConditionsIntro'),
              }}
            />

            <h6>{t('OffererRequirements')}</h6>
            <ul className="list mb-4">
              <li>{t('BuyOfferReq1')}</li>
              <li>{t('BuyOfferReq2')}</li>
              <li>{t('BuyOfferReq3')}</li>
            </ul>

            <h6>{t('PublicationEffects')}</h6>
            <ul className="list mb-4">
              <li>{t('BuyOfferEffect1')}</li>
              <li>{t('BuyOfferEffect2')}</li>
              <li>{t('BuyOfferEffect3')}</li>
            </ul>

            <h6>{t('OfferedPrice')}</h6>
            <p>{t('BuyOfferPriceText')}</p>
          </section>

          <hr className="my-4" />

          <section id="aceptacion" className="anchor-block">
            <h5>{t('AcceptanceConditionsTitle')}</h5>
            <p
              dangerouslySetInnerHTML={{
                __html: t('AcceptanceConditionsIntro'),
              }}
            />

            <h6>{t('AcceptanceEffects')}</h6>
            <ul className="list mb-4">
              <li>{t('AcceptanceEffect1')}</li>
              <li>{t('AcceptanceEffect2')}</li>
              <li>{t('AcceptanceEffect3')}</li>
            </ul>

            <h6>{t('PartyObligations')}</h6>
            <ul className="list mb-4">
              <li>
                <strong>{t('Seller')}:</strong> {t('SellerObligation')}
              </li>
              <li>
                <strong>{t('Buyer')}:</strong> {t('BuyerObligation')}
              </li>
              <li>{t('TransferObligation')}</li>
            </ul>

            <h6>{t('TaxAndLegalAspects')}</h6>
            <p>{t('TaxAndLegalText')}</p>
          </section>

          <hr className="my-4" />

          <p className="text-soft mb-0">
            <em>{t('OfferConditionsDisclaimer')}</em>
          </p>
        </div>
      </div>
    </>
  );
};

export default EquityMarketTermsByDefault;
